import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import {
  Button,
  Divider,
  Flex,
  Input,
  Radio,
  RadioGroup,
  Stack,
  Text,
  useDisclosure,
  VStack,
  Link,
  Image
} from "@chakra-ui/react";

import InputContainer from "./InputContainer";
import FeedbackPopup from "./FeedbackPopup";
import SuccessfullFeedback from "./SuccessfullFeedback";
import { useDeviceWidth } from "../hooks/useDeviceWidth";

import eximpeLogo from "../assets/eximpe_logo_black.png";


const RequestDemoForm = () => {
  const [fwcrm, setFwcrm] = useState({});
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isMobileView } = useDeviceWidth();
  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    ibp: "YES",
  };

  const onValidate = (values) => {
    const errors = {};
    if (!values.firstName) {
      errors.firstName = "Required";
    } else if (!values.lastName) {
      errors.lastName = "Required";
    } else if (!values.email) {
      errors.email = "Required";
    } else if (!values.mobile) {
      errors.mobile = "Required";
    }
    return errors;
  };

  const onFormSubmit = async (values) => {
    let newContact = {
      "First name": values.firstName,
      "Last name": values.lastName,
      Email: values.email,
      Mobile: values.mobile,
      "Are you receiving/sending international business payments?": values.ibp,
    };
    const identifier = values.email;
    console.log(fwcrm)
    await fwcrm.identify(identifier, newContact);
    onOpen();
  };

  // For using CDN in react
  useEffect(() => {
    const script = document.createElement("script");

    script.src = "//in.fw-cdn.com/30380956/214986.js";
    script.async = true;
    script.onload = () => {
      // eslint-disable-next-line
      setFwcrm(window["fwcrm"]);
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Formik
      initialValues={initialValues}
      validate={onValidate}
      onSubmit={onFormSubmit}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        resetForm,
        isSubmitting,
      }) => {
        const onCloseModal = () => {
          resetForm();
          onClose();
        };

        return (
          <Form>
            <Flex
              direction="column"
              justify="center"
              align="center"
              w="full"
              borderRadius="xl"
              shadow={['none', "0px 15px 60px rgba(38, 168, 135, 0.3)"]}
              px={[0, 10]}
              py={[0, 4]}
            >
              {isMobileView && (
                <>
                  <Link href="https://www.eximpe.com/" pb={2}>
                    <Image
                      w="125px"
                      h="33px"
                      src={eximpeLogo}
                    />
                  </Link>
                  <Text
                    fontSize="2xl"
                    fontWeight="semibold"
                    textAlign="center"
                    pb={4}
                  >
                    Request a Demo
                  </Text>
                  <Text fontSize="sm" fontWeight="normal">
                    Please fill out the form below and we will get in touch with
                    you shortly
                  </Text>
                </>
              )}
              <VStack align="start" spacing={3} h="full" w="full" py={6}>
                <InputContainer
                  label="First Name"
                  mandatory
                  error={errors.firstName}
                >
                  <Input
                    type="firstName"
                    name="firstName"
                    size="lg"
                    borderRadius="md"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.firstName}
                    w="full"
                    placeholder="Enter your first name"
                    _placeholder={{ color: "#CBD5E0" }}
                  />
                </InputContainer>
                <InputContainer
                  label="Last Name"
                  mandatory
                  error={errors.lastName}
                >
                  <Input
                    type="lastName"
                    name="lastName"
                    size="lg"
                    borderRadius="md"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.lastName}
                    placeholder="Enter your last name"
                    _placeholder={{ color: "#CBD5E0" }}
                  />
                </InputContainer>
                <InputContainer label="Email" mandatory error={errors.email}>
                  <Input
                    type="email"
                    name="email"
                    size="lg"
                    borderRadius="md"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    placeholder="Enter your email"
                    _placeholder={{ color: "#CBD5E0" }}
                  />
                </InputContainer>
                <InputContainer label="Mobile" mandatory error={errors.mobile}>
                  <Input
                    type="mobile"
                    name="mobile"
                    size="lg"
                    borderRadius="md"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.mobile}
                    placeholder="Enter your mobile number"
                    _placeholder={{ color: "#CBD5E0" }}
                  />
                </InputContainer>
                <InputContainer
                  label="Are you receiving/sending international business payments?"
                  mandatory
                  error={errors.ibp}
                >
                  <RadioGroup
                    onChange={handleChange}
                    name="ibp"
                    defaultValue={values.ibp}
                  >
                    <Stack direction="row">
                      <Radio value="YES">Yes</Radio>
                      <Radio value="NO">No</Radio>
                    </Stack>
                  </RadioGroup>
                </InputContainer>
              </VStack>
              <Divider bg="gray.100" width="full" />
              <Flex justify="flex-end" w="full" py={6}>
                <Button
                  type="submit"
                  bg="#26A887"
                  color="white"
                  fontSize="14px"
                  disabled={isSubmitting}
                  borderRadius="4px"
                  px={6}
                  py={4}
                >
                  Submit
                </Button>
              </Flex>

              <FeedbackPopup isOpen={isOpen} onClose={onCloseModal}>
                <SuccessfullFeedback />
              </FeedbackPopup>
            </Flex>
          </Form>
        );
      }}
    </Formik>
  );
};

export default RequestDemoForm;
